interface CoverModel {
  id: string;
  apiModel: string;
  displayName: string;
  provider: string;
}

export function coverModelFamily(model: CoverModel): string {
  const identity = `${model.id} ${model.apiModel}`.toLowerCase();
  if (model.provider === 'openai' || /openai\/|gpt-image-|chatgpt-image-/.test(identity)) return 'OpenAI';
  if (model.provider === 'gemini' || /gemini-/.test(identity)) return 'Gemini';
  if (identity.includes('black-forest-labs/')) return 'Flux';
  if (identity.includes('recraft/')) return 'Recraft';
  if (identity.includes('sourceful/riverflow')) return 'RiverFlow';
  if (identity.includes('bytedance-seed/seedream')) return 'Seedream';
  return 'Other models';
}

export function coverModelOptions<T extends CoverModel>(models: T[], disabled: (model: T) => boolean) {
  const groups: Array<{ label: string; options: Array<{
    value: string; label: string; selectedLabel: string; title: string; disabled: boolean;
  }> }> = [];
  for (const model of models) {
    const family = coverModelFamily(model);
    const fullName = model.displayName || model.id;
    let label = fullName;
    if (family === 'OpenAI') label = label.replace(/^OpenAI\s+(?:GPT\s+)?(?:Image\s+)?/i, '');
    else if (family === 'Gemini') label = label.replace(/^Gemini\s+/i, '').replace(/\s+Image\b/i, '');
    else if (family !== 'Other models' && label.toLowerCase().startsWith(family.toLowerCase() + ' ')) {
      label = label.slice(family.length + 1);
    }
    label = label.trim() || fullName;
    let group = groups.find(item => item.label === family);
    if (!group) {
      group = { label: family, options: [] };
      groups.push(group);
    }
    group.options.push({
      value: model.id, label,
      selectedLabel: family === 'Other models' ? label : `${family} ${label}`,
      title: fullName, disabled: disabled(model),
    });
  }
  return groups;
}
